export default function () {
  const infoList = [
    {
      key: 'id',
      name: '维保单ID',
    },

    {
      key: 'orderId',
      name: '租赁订单ID',
    },
    {
      key: 'type',
      name: '维保类型',
    },
    {
      key: 'plateNo',
      name: '车牌号',
    },
    {
      key: 'brandName',
      name: '品牌',
    },
    {
      key: 'seriesName',
      name: '车系',
    },
    {
      key: 'modelName',
      name: '车型',
    },
    {
      key: 'customerName',
      name: '司机姓名',
    },
    {
      key: 'customerId',
      name: '司机ID',
    },
    {
      key: 'rentPlanId',
      name: '租赁方案ID',
    },
    {
      key: 'rentPlanName',
      name: '租赁方案名称',
    },
    {
      key: 'rentPlanTypeText',
      name: '租赁方案类型',
    },

    {
      key: 'providerId',
      name: '服务商ID',
    },
    {
      key: 'providerName',
      name: '服务商名称',
    },


    {
      key: 'storeId',
      name: '维修厂ID',
    },

    {
      key: 'maintenanceStateName',
      name: '订单状态', // 审核状态(MaintenanceOrderAuditStateEnum 11维修中|待审核12维修中|已通过13维修中|已驳回21维修完成|待审核22维修完成|已通过23维修完成|已驳回)
    },

    {
      key: 'settlementStateName', // 结算状态(MaintenanceSettlementEnum 0未结算1已结算)
      name: '结算状态',
    },

    {
      key: 'totalAmount',
      name: '维保总费用',
    },
    {
      key: 'customerAmount',
      name: '客户承担维保金额',
    },
    {
      key: 'customerWarningAmount',
      name: '客户罚款',
    },
    {
      key: 'incomeTime',
      name: '进厂时间',
    },
    {
      key: 'leaveTime',
      name: '出厂时间',
    },
    {
      key: 'incomeKm',
      name: '进厂公里数',
    },
    {
      key: 'overMaintenanceKm',
      name: '超保里程',
    },
    {
      key: 'lastMaintenanceKm',
      name: '上次保养里程',
    },

  ]

  return {
    infoList,
  }
}
